const Prayer = {
    SehriEnd: 'sehriEnd',
    Fajr: 'fajr',
    FajrAzan: 'fajrAzan',
    FajrEnd: 'fajrEnd',
    Sunrise: 'sunrise',
    Ishraq: 'ishraq',
    IshraqStart: 'ishraqStart',
    Zawal: 'zawal',
    Dhuhr: 'dhuhr',
    DhuhrAzan: 'dhuhrAzan',
    DhuhrEnd: 'dhuhrEnd',
    Asr: 'asr',
    AsrAzan: 'asrAzan',
    AsrMakruh: 'asrMakruh',
    Maghrib: 'maghrib',
    Iftar: 'iftar',
    MaghribEnd: 'maghribEnd',
    Isha: 'isha',
    IshaAzan: 'ishaAzan',
    IshaEnd: 'ishaEnd',
    None: 'none'
};

export default Prayer;